import ReservationVue from '@/views/sa/reservation/reservation.vue';

const basePath = '/sa/reservation';
const role = 'sa'; // 角色身份

export const SA_RESERVATION_INDEX = 'sa-reservation-index';
export const SA_RESERVATION_EDIT = 'sa-reservation-edit';
export const SA_RESERVATION_TAG = 'sa-reservation-tag';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReservationVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_RESERVATION_INDEX,
      component: () => import(
        /* webpackChunkName: "reservation-index" */
        `@/views/${role}/reservation/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SA_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation-edit" */
        `@/views/${role}/reservation/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/tag`,
      name: SA_RESERVATION_TAG,
      component: () => import(
        /* webpackChunkName: "reservation-tag" */
        `@/views/${role}/reservation/tag.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
  ]
};
